// hooks/useStreetViewController.js

import { useState, useCallback, useMemo } from "react";
import {
  canOpenStreetViewModal,
  isStreetViewDisabled,
} from "../utils/streetViewFlags";

const INITIAL_STATE = {
  isOpen: false,
  coords: null,
  id: null,
  nyme: null,
  adress: null,
  bgColor: null,
  typoloColor: null,
  heading: 0,
  pitch: 0,
};

export function useGoogleStreetViewController() {
  const [streetViewState, setStreetViewState] = useState(INITIAL_STATE);

  const openStreetView = useCallback((cellData) => {
    if (!cellData?.coords?.lat || !cellData?.coords?.lng) {
      console.warn("StreetView: coordonnées manquantes", cellData);
      return;
    }

    // 🚫 Street View désactivé
    if (isStreetViewDisabled()) {
      console.info("StreetView désactivé par feature flag");
      return;
    }

    const { lat, lng } = cellData.coords;

    // 🌍 Mode externe
    if (!canOpenStreetViewModal()) {
      window.open(
        `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${lat},${lng}`,
        "_blank",
        "noopener,noreferrer"
      );
      return;
    }

    // 🪟 Mode modale
    setStreetViewState({
      ...INITIAL_STATE,
      isOpen: true,
      coords: cellData.coords,
      id: cellData.id ?? null,
      nyme: cellData.nyme ?? null,
      adress: cellData.adress ?? null,
      bgColor: cellData.bgColor ?? null,
      typoloColor: cellData.typoloColor ?? null,
      heading: cellData.streetView?.heading ?? 0,
      pitch: cellData.streetView?.pitch ?? 0,
    });
  }, []);

  const closeStreetView = useCallback(() => {
    setStreetViewState((prev) => ({ ...prev, isOpen: false }));
  }, []);

 // ✅ Retourne un objet STABLE avec useMemo
  return useMemo(() => ({
    streetViewState,
    openStreetView,
    closeStreetView,
    streetViewMode: process.env.REACT_APP_STREETVIEW_MODE,
  }), [
    streetViewState, // ❗ Seule dépendance qui peut changer
    openStreetView,   // ✅ Stable grâce à useCallback
    closeStreetView,  // ✅ Stable grâce à useCallback
    // process.env.REACT_APP_STREETVIEW_MODE est constant
  ]);
}
